import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './InterfaceClient.module.scss';
import OngletsClient from './Tabs/OngletsClient';

const InterfaceClient = ({ project_id, montrerMenu }) => {
  const { project_id: projectIdFromUrl } = useParams();
  const resolvedProjectId = project_id || projectIdFromUrl;
  const [flagProjectIdInProjectsList, setFlagProjectIdInProjectsList] =
    useState(false);

  const projects_list = useSelector((state) => state.authentifie.projects_list);

  useEffect(() => {
    // Recherche si le projet est dans la liste des projets de l'utilisateur
    for (let project of projects_list) {
      if (parseInt(resolvedProjectId) === project.project_id) {
        setFlagProjectIdInProjectsList(true);
        break;
      }
    }
  }, [resolvedProjectId, projects_list]);

  let affiche;
  if (flagProjectIdInProjectsList) {
    affiche = (
      <div className={[S.ConteneurProjet].join(' ')}>
        <OngletsClient
          key={resolvedProjectId}
          montrerMenu={montrerMenu}
          inProjectContext
        />
      </div>
    );
  } else {
    affiche = <p>{checkMot('vous_n_avez_pas_acces_projet')}</p>;
  }

  return affiche;
};

export default InterfaceClient;
